import React from "react";
import ReactDOM from "react-dom/client";
import { Layout } from "@/layout.jsx";

const el = document.getElementById("react-app");

if (el) {
  ReactDOM.createRoot(el).render(
    // <DevSupport ComponentPreviews={ComponentPreviews} useInitialHook={useInitial}>
    <Layout />
    // </DevSupport>
  );
}
